// Shared adapters between the friendlies ISO strings ("yyyy-MM-dd" / "HH:mm") and
// the CustomDateTimePicker's Date objects. Built from LOCAL date parts so there's no
// timezone shift, and so the picker renders via date-fns (English) instead of the
// browser-locale native <input type=date> ("TT.mm.jjjj" on a German OS). Used by the
// composer AND the browse filters (desktop bar + mobile sheet).
export const isoToDate = (s) => {
  if (!s) return null;
  const [y, m, d] = String(s).split("-").map(Number);
  return y ? new Date(y, (m || 1) - 1, d || 1) : null;
};

export const dateToISO = (d) =>
  d ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` : "";

export const timeToDate = (t) => {
  if (!t) return null;
  const [h, mi] = String(t).split(":").map(Number);
  const d = new Date();
  d.setHours(h || 0, mi || 0, 0, 0);
  return d;
};

export const dateToTime = (d) =>
  d ? `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}` : "";
